/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return*/

import React, { useState, useEffect } from "react";
import { Paper, Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputTextMaster,
  MasterButton,
  InputCheckboxMaster,
} from "App/Component/ui";

import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  FORM_LOCAL_STORAGE_PAKET_HARGA,
  FORM_LOCAL_STORAGE_PAKET_HARGA_CUSTOM,
  instance3,
  MS_PAKET,
  TYPE_INSTANCE3,
  TYPE_INSTANCE4,
} from "App/constants";

import {
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  changeHandlerLocalStorageForm,
  setLocalStorageAsFormData,
  convertToValidPrice,
  isNull,
} from "App/utils/helpers";

import { STYLE_JENIS_LAYANAN } from "App/Component/layout/MasterData/JenisLayanan/ui";
import {
  TabMaster,
  urlCreate,
  urlGetJenisPaket,
  urlUpdate,
  urlUpdateAll,
} from ".";
import { useSelectOption } from "App/hooks";
import { DEFAULT_SHOW_BUTTON_ALL } from "../../Jasa/ui/FormJasa";
import { WarningMasterPenjualan } from "../../helperMasterPenjualan";
import { accessCode } from "utils/all";

export default function FormRikjang({
  formData,
  setFormData,
  setNewData,

  formHargaTarifBeli,
  setFormHargaTarifBeli,

  formHargaTarifJual,
  setFormHargaTarifJual,

  fieldTarif,

  paketID,
  dataTarif,

  reset,
}) {
  const classes = STYLE_JENIS_LAYANAN();
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const [disabledUpdateAll, setDisabledUpdateAll] = useState(
    DEFAULT_SHOW_BUTTON_ALL
  );
  const jenisPaket = useSelectOption(
    false,
    urlGetJenisPaket,
    TYPE_INSTANCE3,
    "id",
    "info"
  );

  const tarifCBG = useSelectOption(
    true,
    "/wmsfarmasi/master/tarifCbg/list",
    TYPE_INSTANCE4,
    "id",
    "name",
    "data"
  );
  const handleChange = (text) => (e) => {
    changeHandlerLocalStorageForm(text, e, formData, setFormData, MS_PAKET);
  };

  const changeTarifBeli = (id) => (e) => {
    const exceptPrice = formHargaTarifBeli.filter((row) => row.id_tarif !== id);

    setFormHargaTarifBeli([
      ...exceptPrice,
      {
        id_tarif: id,
        harga2: formatRupiah(e.target.value),
        harga: convertToValidPrice(e.target.value),
      },
    ]);

    localStorage.setItem(
      FORM_LOCAL_STORAGE_PAKET_HARGA,
      JSON.stringify([
        ...exceptPrice,
        {
          id_tarif: id,
          harga2: formatRupiah(e.target.value),
          harga: convertToValidPrice(e.target.value),
        },
      ])
    );
  };

  const changeTarifJual = (id) => async (e) => {
    const exceptPrice = formHargaTarifJual.filter((row) => row.id_tarif !== id);
    setFormHargaTarifJual([
      ...exceptPrice,
      {
        id_tarif: id,
        harga_custom2: formatRupiah(e.target.value),
        harga_custom: convertToValidPrice(e.target.value),
      },
    ]);

    localStorage.setItem(
      FORM_LOCAL_STORAGE_PAKET_HARGA_CUSTOM,
      JSON.stringify([
        ...exceptPrice,
        {
          id_tarif: id,
          harga_custom2: formatRupiah(e.target.value),
          harga_custom: convertToValidPrice(e.target.value),
        },
      ])
    );
  };

  useEffect(() => {
    setLocalStorageAsFormData(setFormData, MS_PAKET);
  }, []);

  const add = async (harga) => {
    const data = {
      nama: formData.nama,
      id_jenis_paket: formData.id_jenis_paket,
      barang: formData.barang,
      jasa: formData.jasa,
      fasilitas: formData.fasilitas,
      rikjang: formData.rikjang,
      id_gudang: formData.gudang_id,
      harga,
      status: formData.status,
      id_tarif_cbg: formData.id_tarif_cbg,
      remark: "-",
    };

    return instance3.post(urlCreate, data);
  };

  const update = async (harga) => {
    const data = {
      id: paketID,
      nama: formData.nama,
      id_jenis_paket: formData.id_jenis_paket,
      id_msHarga: formData.id_jenis_harga,
      harga,
      status: formData.status,
      id_tarif_cbg: formData.id_tarif_cbg,
      remark: "-",
    };

    return instance3.post(urlUpdate, data);
  };

  const validateHargaJualBeliPaket = () => {
    let messageValidate = "";
    let stateValidate = true;

    const dataFormHarga = fieldTarif;
    const dataHargaBeli = formHargaTarifBeli;
    const dataHargaJual = formHargaTarifJual;
    /*
    Ada anomali pada saat di map, data yang dimap terbalik dimulai dari array terbesar validasi nya
    saat di short data state nya malah ikut ke ubah, secara urutan di form harga nya juga berubah
      .sort(function(a, b) {
        return b.id - a.id;
      })
    */ 
    dataFormHarga.map((item) => {
      // Cek Harga Beli
      const hargaBeli = dataHargaBeli.filter(
        (row)  => row.id_tarif === item.id
        );
        if (isNull(hargaBeli?.length ?? "") || hargaBeli?.length === 0) {
          messageValidate = `Harga Beli ${item?.name??"".toUpperCase()} Belum Diinput`;
          stateValidate = false;
          return false;
        } else {
          if (isNull(hargaBeli[0]?.harga2)) {
            messageValidate = `Harga Beli ${item?.name??"".toUpperCase()} Belum Diinput`;
            stateValidate = false;
            return false;
          }else{
            // Tidak ngapa ngapain
          }
        }

         // Cek Harga Jual
         const hargaJual = dataHargaJual.filter(
          (row)  => row.id_tarif === item.id
          );
          if (isNull(hargaJual?.length ?? "") || hargaJual?.length === 0) {
            messageValidate = `Harga Jual ${item?.name??"".toUpperCase()} Belum Diinput`;
            stateValidate = false;
            return false;
          } else {
            if (isNull(hargaJual[0]?.harga_custom2)) {
              messageValidate = `Harga Jual ${item?.name??"".toUpperCase()} Belum Diinput`;
              stateValidate = false;
              return false;
            }else{
              // Tidak ngapa ngapain
            }
          }
          return true;
      });

    return {
      messageValidate,
      stateValidate,
    };
  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (formData.nama === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      const checkInputHarga = validateHargaJualBeliPaket();
      if (checkInputHarga.stateValidate === false) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(checkInputHarga.messageValidate);
        return false;
      }
      
      try {
        if (isNull(paketID)) {
          const hargaMerge = setValidHarga(
            formHargaTarifBeli,
            formHargaTarifJual
          );
          const res = await add(hargaMerge);
          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil menambah paket");
            reset();
            setNewData();
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          } else {
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            defaultToastError(res.data.message);
          }
        } else {
          const newHarga = setValidHarga(
            formHargaTarifBeli,
            formHargaTarifJual
          );
          const res = await update(newHarga);

          if (res.data.status === 200) {
            defaultToastSuccess("Berhasil mengubah paket");
            // reset();
            await setNewData();
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          } else {
            defaultToastError(res.data.message);
            setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          }
        }
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const setValidHarga = (harga, hargaCustom) => {
    const validHarga = [];
    dataTarif.map((item) => {
      const findHarga = harga.find((hj) => hj.id_tarif === item.id);
      const findHargaCustom = hargaCustom.find((hb) => hb.id_tarif === item.id);

      if (isNull(paketID)) {
        validHarga.push({
          id_tarif: item.id,
          harga_custom: isNull(findHargaCustom)
            ? 0
            : findHargaCustom.harga_custom,
          harga: isNull(findHarga) ? 0 : findHarga.harga,
        });
      } else {
        const findMsHarga = formData.harga.find((e) => e.id_tarif === item.id);
        validHarga.push({
          id_tarif: item.id,
          harga_custom: isNull(findHargaCustom)
            ? 0
            : findHargaCustom.harga_custom,
          harga: isNull(findHarga) ? 0 : findHarga.harga,
          id_paket: paketID,
          id: findMsHarga.id,
        });
      }
    });

    return validHarga;
  };

  const jenisHarga = useSelectOption(
    false,
    "/wmsfarmasi/master/harga/list",
    TYPE_INSTANCE4,
    "id",
    "name",
    "data"
  );

  const updateAll = async (harga) => {
    const data = {
      id: paketID,
      nama: formData.nama,
      id_jenis_jasa: formData.id_jenis_jasa,
      harga,
      status: formData.status,
      id_tarif_cbg: formData.id_tarif_cbg,
    };

    return instance3.post(urlUpdateAll, data);
  };

  const handleUpdateAll = async (e) => {
    e.preventDefault();
    setDisabledUpdateAll(DISABLED_BUTTON_SUBMIT);
    if (formData.nama === "") {
      setDisabledUpdateAll(DEFAULT_SHOW_BUTTON_ALL);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      const checkInputHarga = validateHargaJualBeliPaket();
      if (checkInputHarga.stateValidate === false) {
        setDisabledUpdateAll(DEFAULT_SHOW_BUTTON_ALL);
        defaultToastError(checkInputHarga.messageValidate);
        return false;
      }
      try {
        const newHarga = setValidHarga(formHargaTarifBeli, formHargaTarifJual);
        const res = await updateAll(newHarga);

        if (res.data.status === 200) {
          defaultToastSuccess("Berhasil mengubah paket");
          // reset();
          setNewData();
          setDisabledUpdateAll(DEFAULT_SHOW_BUTTON_ALL);
        } else {
          defaultToastError(res.data.message);
          setDisabledUpdateAll(DEFAULT_SHOW_BUTTON_ALL);
        }
      } catch (error) {
        setDisabledUpdateAll(DEFAULT_SHOW_BUTTON_ALL);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const gudang = useSelectOption(
    true,
    `/wmsfarmasi/gudang/list?access_code=${accessCode.gudang_farmasi}`,
    TYPE_INSTANCE4,
    "gudangId",
    "name",
    "data"
  );

  return (
    <Paper className={classes.paper}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={3}>
            <InputTextMaster
              name='id'
              label='ID'
              id='id'
              placeholder='-'
              readOnly={true}
              disabled={true}
              value={paketID}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='nama'
              label='NAMA'
              id='nama'
              autoFocus={true}
              value={formData.nama}
              onChange={handleChange("nama")}
              placeholder='Nama Paket'
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='id_jenis_paket'
              label='JENIS PAKET'
              id='id_jenis_paket'
              withSearch={false}
              value={formData.id_jenis_paket}
              data={jenisPaket}
              onChange={handleChange("id_jenis_paket")}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='id_jenis_harga'
              label='JENIS HARGA'
              id='id_jenis_harga'
              withSearch={false}
              disabled={isNull(formData.id_jenis_harga) ? false : true}
              value={formData.id_jenis_harga}
              data={jenisHarga}
              onChange={handleChange("id_jenis_harga")}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='gudang_id'
              label='GUDANG'
              id='gudang_id'
              withSearch={true}
              disabled={isNull(paketID) ? false : true}
              data={gudang}
              value={formData.gudang_id}
              labelValue={formData.gudang_name}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    gudang_id: null,
                    gudang_name: "Pilih Gudang",
                  });
                } else {
                  setFormData({
                    ...formData,
                    gudang_id: e.value,
                    gudang_name: e.label,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name='id_tarif_cbg'
              label='TARIF CBG'
              id='id_tarif_cbg'
              withSearch={true}
              data={tarifCBG}
              value={formData.id_tarif_cbg}
              labelValue={formData.tarif_cbg}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    id_tarif_cbg: null,
                    tarif_cbg: "Pilih CBG",
                  });
                } else {
                  setFormData({
                    ...formData,
                    id_tarif_cbg: e.value,
                    tarif_cbg: e.label,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={3}>
            <div className='pt-1'>
              <InputCheckboxMaster
                checked={formData.status}
                name='status'
                id='status'
                label='Aktif'
                style={{
                  height: "20px",
                  width: "20px",
                }}
                onChange={() =>
                  setFormData({ ...formData, status: !formData.status })
                }
              />
            </div>
          </Grid>
        </Grid>
        <p className='fw-600 mt-2'>HARGA</p>
        <div className='mt-1'>
          <Grid container spacing={3}>
            {fieldTarif.map((e, index) => {
              const hargaBeli = formHargaTarifBeli.find(
                (row) => row.id_tarif === e.id
              );
              const indexHargaBeli = formHargaTarifBeli.indexOf(hargaBeli);

              const hargaJual = formHargaTarifJual.find(
                (row) => row.id_tarif === e.id
              );
              const indexHargaJual = formHargaTarifJual.indexOf(hargaJual);

              return (
                <Grid item sm={3} key={index}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}>
                    <label
                      className='form-control-label'
                      htmlFor={`price-${e.id}`}>
                      {e.name.toUpperCase()}
                    </label>
                    <div
                      id={`price-${e.id}`}
                      style={{
                        display: "flex",
                      }}>
                      <input
                        type='text'
                        placeholder='Harga Beli'
                        className='form-control text'
                        style={{
                          borderTopRightRadius: "0",
                          borderBottomRightRadius: "0",
                        }}
                        onChange={changeTarifBeli(e.id)}
                        value={
                          isNull(formHargaTarifBeli[indexHargaBeli]?.harga2)
                            ? ""
                            : formHargaTarifBeli[indexHargaBeli].harga2
                        }
                      />
                      <input
                        type='text'
                        placeholder='Harga Jual'
                        className='form-control text'
                        style={{
                          borderTopLeftRadius: "0",
                          borderBottomLeftRadius: "0",
                        }}
                        value={
                          isNull(
                            formHargaTarifJual[indexHargaJual]?.harga_custom2
                          )
                            ? ""
                            : formHargaTarifJual[indexHargaJual].harga_custom2
                        }
                        onChange={changeTarifJual(e.id)}
                      />
                    </div>
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </div>

        <div className='mt-2'>
          <TabMaster
            formData={formData}
            setFormData={setFormData}
            paketID={paketID}
          />
        </div>

        <div className='mt-2'>
          <hr style={{ margin: "1rem 0", opacity: "0.3" }} />
          <Grid
            container
            direction='row'
            justifyContent='space-between'
            spacing={2}
            alignItems='center'>
            <MasterButton
              outline={true}
              type={"button"}
              color='danger'
              name='Reset'
              size='md'
              onClick={reset}
            />

            <div>
              {!isNull(paketID) && (
                <MasterButton
                  outline={false}
                  type={"button"}
                  style={{
                    marginRight: "0.5rem",
                  }}
                  onClick={handleUpdateAll}
                  color={disabledUpdateAll.color}
                  name={disabledUpdateAll.label}
                  size='md'
                />
              )}
              <MasterButton
                outline={false}
                type={"button"}
                onClick={(e) => handleSubmit(e)}
                color={disabled.color}
                name={disabled.label}
                size='md'
              />
            </div>
          </Grid>

          <WarningMasterPenjualan />
        </div>
      </form>
    </Paper>
  );
}
